const commonTranslation = {
  mode: 'ko',
  lang: '🇰🇷 한국어',

  cancel: '취소',
  close: '닫기',
  confirm: '확인',
  add: '추가',
  create: '생성',
  save: '저장',
  update: '수정',
  transfer: '이전',
  delete: '삭제',
  reset: '초기화',
  resetSuccess: '초기화 완료',
  resetError: '초기화 실패',
  duplicate: '복사',
  updateDelete: '수정/삭제',
  completeMessage: '되었습니다.',
  cancelMessage: '취소되었습니다.',
  confirmMessage: '확인되었습니다.',
  successMessage: '완료하였습니다.',
  addMessage: '추가되었습니다.',
  updateMessage: '수정되었습니다.',
  transferMessage: '이전되었습니다.',
  deleteMessage: '삭제되었습니다.',
  duplicateMessage: '복사 완료!',
  validateMessage: '을(를) 입력해 주세요.',
  invalidInputBarcodeMessage: '바코드는 11자여야 합니다.',

  // Settings placeholders
  defaultValue: '기본값',
  none: '없음',

  download: '다운로드',
  excelDownload: '액셀 다운로드',
  downloadReasonTitle: '다운로드 사유 입력',
  downloadReasonLabel: '다운로드 사유',
  downloadReasonPlaceholder: '다운로드 사유를 입력해 주세요.',
  downloadReasonRequired: '다운로드 사유를 입력해 주세요.',
  contextMenuDownloadWarningTitle: '우클릭 다운로드 제한',
  contextMenuDownloadWarningDescription:
    '우클릭을 통한 영상/캡쳐 다운로드는 제한되어 있습니다. 필요한 경우 화면 내 제공된 다운로드 기능을 이용해 주세요.',
  actionReasonTitle: '진행 사유 입력',
  actionReasonLabel: '진행 사유',
  actionReasonPlaceholder: '진행 사유를 입력해 주세요.',
  actionReasonRequired: '진행 사유를 입력해 주세요.',
  print: '인쇄',
  languageSetting: '언어 설정',
  downloadCenter: '다운로드 관리자',
  themeSetting: '화면 스타일',
  themeLight: '라이트 모드',
  themeDark: '다크 모드',
  themeSystem: '기기 설정',

  title: 'MDA 마미박스 어드민',
  hospital: '병원',
  room: '병실',
  selectHospital: '병원 선택',
  selectHospitalRoom: '진료실 선택',
  selectDate: '날짜 선택',
  inputBarcode: '바코드 입력',
  searchHospital: '병원 검색',
  searchTypeName: '유형 이름 검색',
  search: '검색',
  date: '기간',
  startSearchDate: '검색 시작일',
  endSearchDate: '검색 종료일',

  new: '신규',
  total: '총',
  now: '현재',
  dataCount: '개',
  dataFilteredMessage1: '개 (',
  dataFilteredMessage2: '개의 데이터에서 필터됨)',
  table: {
    showTotal: '{{start}}-{{end}} / 총 {{total}}개',
  },
  actions: '작업',
  refresh: '새로고침',
  noInfo: '정보 없음',
  status: '상태',
  itemLabel: '항목',
  refreshed: '새로고침 완료',
};

export default commonTranslation;
